<a *ngIf="isClickableUrl(href);else notClickable" [href]="href" target="_blank">{{ href }}</a>
<ng-template #notClickable>
    <span>{{ href }}</span>
</ng-template>